<template>
    <div class="content-body">
        <div class="container pd-x-0">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-style1 mg-b-10">
<!--                            <li class="breadcrumb-item"><a href="#">Dashboard</a></li>-->
<!--                            <li class="breadcrumb-item active" aria-current="page">Sales Monitoring</li>-->
                        </ol>
                    </nav>
                    <h4 class="mg-b-0 tx-spacing--1">Welcome
                        <span v-if="system.userInfo != null">
                            {{system.userInfo.firstName}}
                        </span></h4>
                </div>
                <div class="d-none d-md-block">
                    <new-account-button></new-account-button>
                    <router-link to="/new-officer" class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"><i data-feather="plus" class="wd-10 mg-r-5"></i> New Officer</router-link>
                    <button style="background-color: #6d0606; border-color: #6d0606;" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <download-excel
                                class   = "lnr-cloud-download"
                                style="cursor: pointer;"
                                :data   = "system.dashboard.data"
                                worksheet = "My Worksheet"
                                :name    = "$route.name+'.xls'">
                            <span> <i data-feather="file" class="wd-10 mg-r-5"></i> Generate Report</span>
                        </download-excel>
                    </button>
                </div>
            </div>

            <!--TODO TOP CARDS-->
            <top-cards></top-cards>
            <!--TODO GROWTH-->
            <stats></stats>
            <!--TODO REVENUE-->
<!--            <revenue></revenue>-->
            <!--TODO HISTORY-->
<!--            <history></history>-->

        </div><!-- container -->
    </div>
</template>

<script>
    // @ is an alias to /src
    import TopCards from "../../components/card/TopCards";
    // import Growth from "../../components/card/Growth";
    import Stats from "../../components/card/Stats";
    // import Revenue from "../../components/card/Revenue";
    // import History from "../../components/card/History";
    import NewAccountButton from "../../components/button/NewAccountButton";
    import {mapState} from 'vuex'
    export default {
        name: 'Home',
        components:{
            TopCards,
            Stats,
            NewAccountButton,
            // Growth,
            // Revenue,
            // History
        },
        data(){
            return{

            }
        },
        computed:{
            ...mapState([
                'system'
            ])
        }
    }
</script>
